  /**
 * PlatinMarket Sanal Mağaza Sistemi Javascript Kütüphanesi v1.0.0
 * Burak DOĞAN <burak@platinmarket.com>
 * Tüm hakları saklıdır.
 */

(function(global, factory) {
	'use strict';
	[ global.PlatinMarket, global.Statr ] = factory(window.EvEmitter);
})(this,

// --------------------------  factory -------------------------- //

function factory(EvEmitter) {

	var $ = window.jQuery;
	var console = window.console;

	// -------------------------- helpers -------------------------- //

	// Get Object key by dot notation path
	function dot_get(obj, path) {
		var currentObj = obj,
        keys = path.split("."), i, l = keys.length, key;
        for( i = 0; i <= keys.length - 1; ++i ) {
			key = keys[i];
			if (!currentObj.hasOwnProperty(key)) return undefined;
			currentObj = currentObj[key];
        }
		return currentObj;
	}

	// Set Object key by dot notation path
	function dot_set(obj, path, value) {
		var currentObj = obj,
        keys = path.split("."), i, l = keys.length, key;
        for( i = 0; i <= keys.length - 1; ++i ) {
			key = keys[i];
			currentObj[key] = keys.length - 1 === i ? value : typeof currentObj[key] == "object" ? currentObj[key] : {};
			currentObj = currentObj[key];
        }
	}

	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
		a[ prop ] = b[ prop ];
	  }
	  return a;
	}

	// clone object
	function clone(obj) {
      if (obj === null || !$.isPlainObject(obj) || 'isActiveClone' in obj)
        return obj;

      if (obj instanceof Date)
        var temp = new obj.constructor(); //or new Date(obj);
      else
        var temp = obj.constructor();

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          obj['isActiveClone'] = null;
          temp[key] = clone(obj[key]);
          delete obj['isActiveClone'];
        }
      }

      return temp;
    }

	// turn element or nodeList into an array
	function makeArray( obj ) {
	  var ary = [];
	  if ( Array.isArray( obj ) ) {
		// use object if already an array
		ary = obj;
	  } else if ( typeof obj.length == 'number' ) {
		// convert nodeList to array
		for ( var i=0; i < obj.length; i++ ) {
		  ary.push( obj[i] );
		}
	  } else {
		// array of single index
		ary.push( obj );
	  }
	  return ary;
	}

	// Get querystring parameter from url
	function getQueryString(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	(function () {

		 if ( typeof window.CustomEvent === "function" ) return false;

		 function CustomEvent ( event, params ) {
			 params = params || { bubbles: false, cancelable: false, detail: undefined };
			 var evt = document.createEvent('CustomEvent');
			 evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
			 return evt;
		 }

		 CustomEvent.prototype = window.Event.prototype;

		 window.CustomEvent = CustomEvent;
	})();

	// -------------------------- Data -------------------------- //

	var _data = {};

	// -------------------------- Default Configure -------------------------- //

	_data = {
		Configure: {

			// JqZoom Options
			JqZoom: {
				zoomType: 'standart',
				preloadText: 'Yükleniyor..',
				preloadImages: false,
				title: false,
				showEffect: 'show',
				hideEffect: 'hide',
				zoomWidth: 300,
				zoomHeight: 300,
				xOffset: 10
			},

			// KeepSession Options
			KeepSession: {
				interval: 180000,
				url: "/main/order_steps_keep_session.asp"
			},

			// Lightbox Options
			Lightbox: {
				fullscreenEl: false,
				history: false,
				shareEl: false,
				closeOnScroll: false,
				pinchToClose: false,
				closeElClasses: [ ],
				clickToCloseNonZoomable: false
			},

			// JCarousel Options
			JCarousel: {
				jcarousel: {
					wrap: 'last',
					scroll: 1,
					animation: {
						duration: 500
					}
				},
				autoscroll: {
					target: '+=1',
					interval: 3000,
					autostart: true
				},
				equalHeight: true,
				buttons: true,
				prev: function(element){
					return $(element).next("div.jcarousel-prev");
				},
				next: function(element){
					return $(element).next("div.jcarousel-prev").next("div.jcarousel-next")
				},
				group: 1
			},

			// SexyLightbox Options
			Sexylightbox: {
				color: 'white',
				dir: '/js/src/sexylightbox',
				imagesdir: '/js/src/sexylightbox'
			},

			// Autocomplate Options
			Autocomplate: {
				delay: 400,
				minChars: 0,
				scrollHeight: 250,
				selectFirst: false,
				multiple: false,
				matchContains: false,
				mustMatch: false,
				matchCase: true,
				autoFill: false
			},

			// Validation definations
			ValidationRules: {
				_messages: {
					adres_tanimi: "Lütfen adres tanımı belirleyin.",
					il: "Lütfen şehir seçiniz/yazınız.",
					ilce: "Lütfen ilçe seçiniz/yazınız.",
					adres: "Lütfen adres yazınız.",
					tel: "Lütfen telefon no. yazınız.",
					gsm: {required: "Lütfen gsm no. yazınız.", gsm: "Lütfen geçerli bir gsm numarası yazınız."},
					ad: "Lütfen adınızı yazınız.",
					konuk_ad: "Lütfen adınızı yazınız.",
					soyad: "Lütfen soyadınızı yazınız.",
					tc_kimlik: "TC kimlik no hatalı. Kontrol ediniz.",
					firma_unvan: "Lütfen firma unvanını yazınız.",
					vergi_daire: "Lütfen vergi dairesi yazınız.",
					vergi_no: "Lütfen vergi numarası yazınız.",
					TcIdentity: "Lütfen kimlik numarasını kontrol ediniz.",
					checked: "Lütfen işaretleyiniz",
					gizlilik_politikasi_onay: "Devam etmek için gizlilik politikasını kabul etmeniz gerekiyor."
				},
				adres: {
					_base: {
						adres_tanimi : "required",
						il: "required",
						ilce: "required",
						adres: "required",
						tel: "Telefon",
						gsm: {required: true, gsm: true},
						ad: "required",
						soyad: "required",
						tc_kimlik: "TcIdentity"
					},
					fatura: {
						ad: { required: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "bireysel"; } } },
						soyad: { required: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "bireysel"; } } },
						tc_kimlik: { TcIdentity: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "bireysel"; } } },
						firma_unvan: { required: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "kurumsal"; } } },
						vergi_daire: { required: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "kurumsal"; } } },
						vergi_no: { required: { depends: function(){ return $("form [name='fatura_tip']").data("value") == "kurumsal"; } } }
					}
				},
				
				teslimat_fatura_bilgileri: {
					_base: {
						gizlilik_politikasi_onay: "checked",
						konuk_ad: "required",
						konuk_soyad: "required",
						konuk_email: {required: true, email: true},
						siparis_notu: { required: { depends: function(){ return PM.Get("Application" , "x_not_zorunlu") === 1; } } },
						teslimat_tanim: "required",
						teslimat_ad: "required",
						teslimat_soyad: "required",
						teslimat_tc_kimlik: { TcIdentity: { depends: function(){ return $(this).closest("form").data("same_invoice_data"); } }, 
							remote: {
								param: {
									url: "/scripts/edevlet_kontrol.asp",
									type: "post",
									data: {
									  tckn: function(){
											return $("#teslimat_tc_kimlik").val();
										},
									  ad: function() {
										return $( "#teslimat_ad" ).val();
									  },
									  soyad: function() {
										return $( "#teslimat_soyad" ).val();
									  },
									  dogum_yil: function() {
										return $( "#teslimat_dogum_yil" ).val();
									  }
									}
								},
								depends: function() { 
									return PM.Get("Application" , "x_tc_kimlik_zorunlu") === 3 && $(this).closest("form").data("same_invoice_data") && $( "#teslimat_dogum_yil" ).val().length > 0;
									},
							  }
						},
						teslimat_dogum_yil: { required: { depends: function(){ return PM.Get("Application" , "x_tc_kimlik_zorunlu") === 3 && $(this).closest("form").data("same_invoice_data"); } } },
						teslimat_ulke: "required",
						teslimat_sehir: "required",
						teslimat_ilce: "required",
						teslimat_adres: "required",
						teslimat_tel: "Telefon",
						teslimat_gsm: { required:true, gsm: { depends: function(){ return $(this).closest("form").find("[name='teslimat_ulke']")[0].value === 'Türkiye'; } }, Telefon: { depends: function(){ return !$(this).closest("form").find("[name='teslimat_ulke']")[0].value === 'Türkiye'; } } },
						fatura_tanim: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_tip: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_ad: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data") && $(this).closest("form").data("invoice_type") == "bireysel"; } } },
						fatura_soyad: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data") && $(this).closest("form").data("invoice_type") == "bireysel"; } } },
						fatura_tc_kimlik: { 
							required: { 
								depends: function(){ 
									let check = PM.Get("Application" , "x_tc_kimlik_zorunlu");
									check = check == 1 || check == 3;
									return check && $(this).closest("form").data("same_invoice_data") == false && $(this).closest("form").data("invoice_type") == "bireysel";
								},
							},
							TcIdentity: { depends: function(){ return $(this).closest("form").data("same_invoice_data") == false; } }, 
							remote: {
								param: {
									url: "/scripts/edevlet_kontrol.asp",
									type: "post",
									data: {
									  tckn: function(){
											return $("#fatura_tc_kimlik").val();
										},
									  ad: function() {
										return $( "#fatura_ad" ).val();
									  },
									  soyad: function() {
										return $( "#fatura_soyad" ).val();
									  },
									  dogum_yil: function() {
										return $( "#fatura_dogum_yil" ).val();
									  }
									}
								},
								depends: function() { 
									return PM.Get("Application" , "x_tc_kimlik_zorunlu") === 3 && $(this).closest("form").data("same_invoice_data") == false && $( "#fatura_dogum_yil" ).val().length > 0;
									},
							  }
						},
						fatura_dogum_yil: { required: { depends: function(){ return PM.Get("Application" , "x_tc_kimlik_zorunlu") === 3 && $(this).closest("form").data("same_invoice_data") == false && $(this).closest("form").data("invoice_type") == "bireysel" } } },
						fatura_ulke: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_sehir: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_ilce: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_adres: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_tel: { Telefon: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						fatura_gsm: { gsm: { depends: function(){ return !$(this).closest("form").data("same_invoice_data"); } } },
						faturam_siparisimle_gelsin: { checked: false },
						fatura_firma_unvan: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data") && $(this).closest("form").data("invoice_type") == "kurumsal"; } } },
						fatura_vergi_daire: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data") && $(this).closest("form").data("invoice_type") == "kurumsal"; } } },
						fatura_vergi_no: { required: { depends: function(){ return !$(this).closest("form").data("same_invoice_data") && $(this).closest("form").data("invoice_type") == "kurumsal"; } } }
					}
				}
			},

			// Custom Validation Methods
			ValidationMethods: {
				// Gsm number validation
				gsm: function(value, element){
					if (!value) return true;
					var stripped = value.replace(/[\D()+-]|ext\.?/gi,"");
					return /^((5[0123456]\d))\d{7}$/.test(stripped);
				},
				GSM: function(value, element){
					if (!value) return true;
					var stripped = value.replace(/[\D()+-]|ext\.?/gi,"");
					if (stripped.length != 10) return true;
					return stripped.match(/((54\d)|(53\d)|(50\d)|(55\d)|(56\d))\d{7}/);
				},
				// Turkey Citizen Identity number validation
				TcIdentity: function(value, element){
					if ($(element).prop("disabled") || PM.Get("Application" , "x_tc_kimlik_zorunlu") !== 1) return true;
					var toplam = Number(value.substring(0,1)) + Number(value.substring(1,2)) + Number(value.substring(2,3)) + Number(value.substring(3,4)) + Number(value.substring(4,5)) + Number(value.substring(5,6)) + Number(value.substring(6,7)) + Number(value.substring(7,8)) + Number(value.substring(8,9)) + Number(value.substring(9,10));
					var strtoplam = String(toplam);
					var onunbirlerbas = strtoplam.substring(strtoplam.length,strtoplam.length-1);
					return onunbirlerbas == value.substring(10,11);
				},
				// Telephone number validation
				Telefon: function(value, element){
					if (!value) return true;
					if ($(element).prop("disabled")) return true;
					if (value.trim().length === 0) return false;
					var stripped = value.replace(/[\D()+-]|ext\.?/gi,"");
					if(stripped.length != 10) return true;
					return stripped.match(/([2-5]\d\d)\d{7}/);
				},
				// Checked for type checkbox
				checked: function(value, element){
					if ($(element).attr("type") != "checkbox" || $(element).prop("disabled")) return true;
					return $(element).prop("checked");
				}
			}
		}
	}

	// -------------------------- Statr -------------------------- //

	function Statr(data) {
		this.data = data || {};
	}

	function dot_get(obj, path) {
		var currentObj = obj,
        keys = path.split("."), i, l = keys.length, key;
        for( i = 0; i <= keys.length - 1; ++i ) {
			key = keys[i];
			if (!currentObj.hasOwnProperty(key)) return undefined;
			currentObj = currentObj[key];
        }
		return currentObj;
	}

	Statr.prototype = Object.create(EvEmitter.prototype);

	// Get value by key
	Statr.prototype.get = function(key) {
		return dot_get(this.data, key) || null;
	}

	// Set value by key & value
	Statr.prototype.set = function(key, value) {
		const oldValue = this.get(key);
		const oldObj = Object.assign({}, this.data);
		dot_set(this.data, key, value);
		this.emitEvent(key, [ value, oldValue ]);
		this.emitEvent('change', [ Object.assign({}, this.data), oldObj ]);
	}

	// Set value by key & value
	Statr.prototype.connect = function(key, cb) {
		const _self = this;
		return function(v) {
			_self.set(key, v);
			if (!!cb) cb.apply(_self, arguments);
		}
	}

	// -------------------------- PlatinMarket -------------------------- //

	function PlatinMarket(_CsrfToken, _ActionPage, _ServerTime) {
		this.CSRFToken = _CsrfToken;
		this.ActionPage = _ActionPage;
		this.ServerTime = _ServerTime;
		this.on("before.init.platinmarket", function(){
			if (window && CustomEvent && window.dispatchEvent) {
				window.dispatchEvent(new CustomEvent("before.init.platinmarket"));
			}
		});
		// PM Ready Event
		this.on("ready", function(){

			// InFrame Emit Ready Event
			if (this.InIframe() && parent.PM) parent.PM.emitEvent('ready.iframe', [window]);

		});
	}

	PlatinMarket.prototype = Object.create(EvEmitter.prototype);

	// Set Scope Variables like Application, Session etc.
	PlatinMarket.prototype.Set = function(Scope, Name, Value) {
		dot_set(_data, Scope + "." + Name, Value);
		return Value;
	};

	// Get Scope Variables like Application, Session etc.
	PlatinMarket.prototype.Get = function(Scope, Name) {
		return clone(dot_get(_data, Scope + "." + Name));
	};

	// Check Scope Variables defined Before.
	PlatinMarket.prototype.Defined = function(Scope, Name) {
		return dot_get(_data, Scope + "." + Name) != undefined;
	};

	// Define if not defined
	PlatinMarket.prototype.SetDefault = function(Scope, Name, Value) {
		if (this.Defined(Scope, Name)) return;
		this.Set(Scope, Name, Value);
	};

	// Call Page Functions
	PlatinMarket.prototype.OnPage = function(_ActionPage, _PageFunctions){
		if (!Array.isArray(_ActionPage)) _ActionPage = [_ActionPage];
		if (_ActionPage.indexOf(this.ActionPage) === -1 && _ActionPage.indexOf("*") === -1) return;
		_PageFunctions();
	};

	// -------------------------- Methods -------------------------- //

	// Deprecated for: hizli_satin_al
	PlatinMarket.prototype.HizliSatinAl = function(type, product_id){
		if (type == 'tek')
			 return window.location.href = "?islem=hizli_satin_al_tek2&sid=" + encodeURIComponent(this.CSRFToken) + "&uid=" + product_id.toString();
		if (type == 'beraber')
			return window.location.href = "?islem=hizli_satin_al_beraber2&sid=" + encodeURIComponent(this.CSRFToken) + "&uid=" + product_id.toString();
	};

	// Deprecated for: hemenal_fonksiyon
	PlatinMarket.prototype.HemenAl = function(product_id) {
		PM.HizliSatinAl('beraber',product_id.toString());
		//window.location.href = "?islem=hizli_satin_al_tek2&sid=" + encodeURIComponent(this.CSRFToken) + "&uid=" + product_id.toString();
	};

	// UserFS Wrapper
	PlatinMarket.prototype.UserFS = {
		PublicUrl: function(file) { return PM.Get("UserFS", 'PublicUrl("")') + file.replace(/^\/+/, ""); }
	};

	// SharedFS Wrapper
	PlatinMarket.prototype.SharedFS = {
		PublicUrl: function(file) { return PM.Get("SharedFS", 'PublicUrl("")') + file.replace(/^\/+/, ""); }
	};

	// Keep Session Open
	PlatinMarket.prototype.KeepSession = function(_options){
		(function(PM){
			_options = extend(PM.Get("Configure", "KeepSession"), _options || {});
			return PM.Timer(_options.interval, function(){
				PM.Ajax({ url: _options.url + "?_t=" + (new Date().getTime()), dataType: "html" })
					.then(function(response){
						console.info("Session refresh complated. Got response " + response);
					}, function(err){
						console.warn("Session refresh error.", err);
					});
			});
		})(this);
	};

	// Make ajax call
	PlatinMarket.prototype.Ajax = function(_options, _data) {
		return new Promise((resolve, reject) => {
			if (typeof _options == "string") _options = {url: _options};
			_options = _options || {};
			_options.data = _options.data || _data;
			_options = extend({
				type: _options.data ? "POST" : "GET",
				dataType: "xml",
				cache: true,
				success: function(data) {
					return resolve(data);
				},
				error: function(xhr) {
					var err = new Error(xhr.status.toString() + " " + xhr.statusText);
					err.responseText = xhr.responseText;
					return reject(err);
				}
			}, _options);
			$.ajax(_options);
		});
	};

	// Cache remember url
	PlatinMarket.prototype.RememberUrl = function(url) {
		if (this.Defined("Cache", url)) return Promise.resolve(this.Get("Cache", url));
		return this.Ajax(url).then((data) => this.Set("Cache", url, data), console.error);
	}

	// Get Countries
	PlatinMarket.prototype.Countries = function() {
		return this.RememberUrl(this.SharedFS.PublicUrl("data/ilceler.xml?q=" + this.Get("AppConfig", "DataCacheKey")))
			.then((data) => $(data).find("ulke").toArray().map(e => $(e).attr("isim").toString().trim()), console.error);
	};

	// Get Cities
	PlatinMarket.prototype.Cities = function(country) {
		return this.RememberUrl(this.SharedFS.PublicUrl("data/ilceler.xml?q=" + this.Get("AppConfig", "DataCacheKey")))
			.then(d => $(d).find("ulke[isim='" + country + "'] il").toArray().map(e => $(e).attr("isim").toString().trim()));
	};

	// Get Towns
	PlatinMarket.prototype.Towns = function(country, city) {
		return this.RememberUrl(this.SharedFS.PublicUrl("data/ilceler.xml?q=" + this.Get("AppConfig", "DataCacheKey")))
			.then(d => $(d).find("ulke[isim='" + country + "'] il[isim='" + city + "'] ilce").toArray().map((el) => $(el).text().toString().trim()))
	};

	// Get Product detail
	PlatinMarket.prototype.ProductDetail = function(id) {
		return this.Ajax({ url: "/ajax/product/" + id.toString(), dataType: 'json' });
	}

	// Get Product variant detail
	PlatinMarket.prototype.ProductVariantDetail = function(proId, subProId) {
		return this.Ajax({ url: "/ajax/product/" + proId.toString() + "/variant/" + subProId, dataType: 'json' });
	}

	// Get product variants
	PlatinMarket.prototype.ProductVariants = function(id) {
		return this.ProductDetail(id)
			.then((detail) => detail.pro_VARIANTS.map((variant) => {
				return {
					id: variant.alt_urun_ID,
					image: variant.alt_URUN_RESIM || null,
					price: (variant.alt_urun_FIYAT_TIPI === 0 ? (detail.pro_PRICE + variant.alt_urun_FIYAT) : (variant.alt_urun_FIYAT_TIPI === 1 ? (detail.pro_PRICE - variant.alt_urun_FIYAT) : variant.alt_urun_FIYAT)),
					quantity: variant.alt_urun_STOK,
					sku: variant.alt_urun_STOK_KODU,
					values: variant.alt_urun_VAR_DEGER.map(function(variantId) {
						var _variant = detail.pro_VARIANT_NAMES.find(function(_v) { return _v.varyasyon_ID.toString() ===  variantId.toString(); });
						return {
							id: _variant.varyasyon_ID,
							name: _variant.varyasyon_ISMI,
							value: _variant.varyasyon_DEGERLERI
						};
					})
				};
			}));
	}

	// Apply data on dom
	PlatinMarket.prototype.ApplyData = function(node, data) {
		return new Promise((resolve, reject) => {
			setTimeout(function(){
				node = node.jquery ? node : $(node);
			});
		});
	}

	// Check Is Mobile
	PlatinMarket.prototype.IsMobile = function() {
		var md = window.md ? window.md : window.md = new MobileDetect(window.navigator.userAgent);
		return (md.mobile() !== null && md.tablet() === null);
	};

	// Global load images lazy-load or etc.
	PlatinMarket.prototype.LoadImages = function() {
		window.callCount = window.callCount || 0;
		function _LoadImages() {
			window.callCount++;
			if ($("img[data-original]")) $("img[data-original]:not(.st_tab_view img, .jcarousel-container img)").each(function(){ if ($(this).attr("data-lazyload-ready") != "true") $(this).lazyload().attr("data-lazyload-ready", "true"); });
			$("img[data-original]:not([data-lazyload-ready='true'], .st_tab_view img[data-original])").each(function(){
				if ($(this).attr("data-lazyload-ready") == "true") return;
				$(this).attr("src", $(this).attr("data-original"));
				$(this).attr("data-lazyload-ready", "true");
			});
			$(".st_tab_view").each(function(index, element){
				if ($(".st_tab_view").length - 1 === index) return $(element).find("img[data-original]").each(function(){ if ($(this).attr("data-lazyload-ready") != "true") $(this).lazyload().attr("data-lazyload-ready", "true"); });
				$(element).on("fadeIn", function(){
					if ($(element).css("display") != "block") return;
					$(element).find("img[data-original]:not([data-lazyload-ready='true'])").each(function(){ if ($(this).attr("data-lazyload-ready") != "true") $(this).lazyload().attr("data-lazyload-ready", "true"); });
					$(window).triggerHandler("resize");
				});
			});
		}
		if (window.callCount == 0) {
			$("body").off("load_images").on("load_images", _LoadImages);
			$(document).ready(_LoadImages);
			$(window).on('load', _LoadImages);
			return;
		}
		_LoadImages();
	};

	// Detect iframe
	PlatinMarket.prototype.InIframe = function() {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	};

	// Timer
	PlatinMarket.prototype.Timer = function(interval, callback){
		var interval = interval || 100;
		if (!callback) return false;
		_timer = function (interval, callback) {
			this.stop = function () {
				clearInterval(self.id);
			};
			this.internalCallback = function () {
				callback(self);
			};
			this.reset = function (val) {
				if (self.id)
				clearInterval(self.id);
				var val = val || 100;
				this.id = setInterval(this.internalCallback, val);
			};
			this.interval = interval;
			this.id = setInterval(this.internalCallback, this.interval);
			var self = this;
		};
		return new _timer(interval, callback);
	};

	PlatinMarket.prototype.isNumeric = function(obj) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !Array.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	};

	// Validate Options
	PlatinMarket.prototype.ValidationOptions = function(_options, form_name){
		if (typeof _options == "string") {
			form_name = _options;
			_options = {};
		}
		return $.extend({
			errorElement: this.InIframe() ? "span" : "em",
			errorClass: "help-block " + this.ActionPage + "_error",
			errorPlacement: function(error, element) {
				element.parent().find("span.help-block, em").remove();
				element.parent().append(error);
			},
			highlight: function(element, errorClass, validClass) {
				if ($(element).parent("div")[0] && $(element).parent("div")[0].nodeName == "DIV") $(element).parent().addClass("has-error");
				$(element).addClass(errorClass).removeClass(validClass);
				if (element.id) $(element.form).find(this.errorElement + "[for=" + element.id + "]").addClass(errorClass);
			},
			unhighlight: function(element, errorClass, validClass) {
				if ($(element).parent("div")[0] && $(element).parent("div")[0].nodeName == "DIV") $(element).parent().removeClass("has-error");
				$(element).removeClass(errorClass).addClass(validClass);
				if (element.id) $(element.form).find(this.errorElement + "[for=" + element.id + "]").removeClass(errorClass);
			},
			submitHandler: function(form) {
				$(form).find("button[type='submit'], input[type='submit']").disable();
				var e = new $.Event("submit." + this.ActionPage + ".form");
				$(form).triggerHandler(e);
				if (e.isDefaultPrevented()) return false;
				form.trigger('submit');
			}
		}, $.extend(this.GetValidationRules(form_name), _options || {}));
	};

	// Validation Rules
	PlatinMarket.prototype.GetValidationRules = function(form_name) {
		form_name = form_name || PM.ActionPage;
		var messages = this.Get("Configure", "ValidationRules._messages");
		if (form_name.indexOf(".") == -1) form_name = form_name + "._base";
		var rules = this.Get("Configure", "ValidationRules." + form_name) || {};
		if (form_name.indexOf("._base") == -1) rules = $.extend(this.Get("Configure", "ValidationRules." + form_name.replace(/\.(.*)/, "._base")) || {}, rules);
		rules = {
			rules: rules,
			messages: messages
		};
		this.emitEvent("set." + form_name, [rules]);
		return rules;
	};

	// Rate Product
	PlatinMarket.prototype.RateProduct = function(productId, rating){
		return PM.Ajax({url: "/scripts/urune_oy_ver.asp?islem=urune_oy_ver&sid=" + this.CSRFToken + "&urun_id=" + productId.toString() + "&_t" + (new Date().getTime()), dataType: "html"}, {rating: rating});
	}

	// Init Location Selector
	PlatinMarket.prototype.InitLocationSelector = function(_countrySelector, _citySelector, _townSelector, _countryFilter) {
		if (typeof _countryFilter != "function") _countryFilter = function(country){ return PM.Get("Application", "strSIPARIS_ULKELERI").indexOf("{" + country + "}") > -1; };

		return new Promise((resolve, reject) => {
			var $_country = $(_countrySelector).length > 0 ? $(_countrySelector) : undefined;
			var $_city = $(_citySelector).length > 0 ? $(_citySelector) : undefined;
			var $_town = $(_townSelector).length > 0 ? $(_townSelector) : undefined;

			if (!$_country || ($_town && !$_city)) return resolve();

			$_country.on("change", function(){
				if (!$_city) return;
				$_city.clear().disable();
				if ($_town) $_town.clear().disable();
				PM.Cities($(this).val())
					.then(function(cities){

						// Emit event for fill
						var e = new $.Event('before.fill', { cities: cities });
						$_city.trigger(e);
						cities = e.cities;

						if (!cities.length) return $_city.add($_town).convertInputBox({show: true}).trigger("change");

						$_town.convertInputBox({show: false});
						$_city
							.convertInputBox({show: false})
							.fill(([{name: "Seçiniz", value:""}]).concat(cities))
							.val($_city.attr("data-selected") && cities.indexOf($_city.attr("data-selected")) > -1 ? $_city.attr("data-selected") : "")
							.trigger("change")
							.enable();
					});
			});

			$_city.on("change", function(){
				if (!$_town || !$(this).val()) return;
				$_town.clear().disable();
				PM.Towns($_country.val(), $(this).val())
					.then(function(towns){

						// Emit event for fill
						var e = new $.Event('before.fill', { towns: towns });
						$_town.trigger(e);
						towns = e.towns;

						if (!towns.length) return $_town.convertInputBox({show: true}).trigger("change");

						$_town
							.convertInputBox({show: false})
							.fill(([{name: "Seçiniz", value:""}]).concat(towns))
							.val($_town.attr("data-selected") && towns.indexOf($_town.attr("data-selected")) > -1 ? $_town.attr("data-selected") : "")
							.trigger("change")
							.enable();
					});
			});

			PM.Countries()
				.then(function(countries){

					// Emit event for fill
					var e = new $.Event('before.fill', { countries: countries });
					$_country.trigger(e);
					countries = e.countries;

					$_country.clear().fill(_.filter(countries, _countryFilter));
					$_country.val($_country.attr("data-selected") || countries[0]);
					$_country.trigger("change");
					resolve();
				});
		});
	};

	// Depends to field for validation
	PlatinMarket.prototype.depends = function(field, expectedVal) {
		return function(){
			return $(field).val().toString() === expectedVal.toString();
		}
	};

	// -------------------------- jQuery -------------------------- //

	PlatinMarket.makeJQueryPlugins = function(jQuery) {
		jQuery = jQuery || window.jQuery;
		if ( !jQuery ) {
			return;
		}

		// set local variable
		$ = jQuery;

		// Tab selector
		$.fn.tabSelector = function(options) {

			// Return given tab
			if (['string', 'number'].indexOf(typeof options) > -1) {
				if (options === 'all') return $(this).toArray().map(el => $(el).data('_tab'));
				return $(this).toArray().map(el => $(el).data('_tab')).find(i => !!i && i[0] === options);
			}

			// Parse options
			options = Object.assign({
				target: 'tabTarget',
				selected: null,
				activeClass: 'active',
				value: null,
				change: () => {}
			}, options || {});

			// Get target contents
			const tabs = $(this).toArray().map((el, i) => [ (options.value ? $(el).data(options.value) : i), $(el), $($(el).data(options.target)), false ]);

			// Set tabs to element
			tabs.forEach(t => t[1].data('_tab', t));

			// Set selected
			if (options.selected === null) {
				const selectedNode = tabs.find(t => t[0] === options.value);
				options.selected = !!selectedNode ? selectedNode[0] : tabs[0][0];
			}

			// Holds current value
			let currentValue = null;

			// Tab changer
			const changeTab = (tab) => {
				// Check already selected
				if (!tab || currentValue === tab[0]) return;

				// Emit event
				const changeEvt = $.Event('change.tab');
				$(this).trigger(changeEvt, tab[0]);
				if (changeEvt.isDefaultPrevented()) return;

				// Maintain current active tab
				const currentTab = tabs.find(t => t[0] === currentValue);
				if (currentTab) {
					currentTab[1].removeClass(options.activeClass);
					currentTab[2].hide();
				}

				// Select new tab
				const newTab = tabs.find(t => t[0] === tab[0]);
				if (newTab) {
					newTab[1].addClass(options.activeClass);
					newTab[2].show();
				}

				// Set tabs
				tabs.forEach(t => t[3] = (t === tab));

				// Emit event
				const changedEvt = $.Event('changed.tab');
				newTab[1].trigger(changedEvt, currentValue = tab[0]);

				// Callback
				options.change.call(options, tab[0], tab);
			};

			// Select default tab
			const initialSelected = tabs.find(t => t[0] === options.selected);
			changeTab(initialSelected);
			tabs.filter(t => t !== initialSelected).forEach(t => t[2].hide());

			// Listen click event
			$(this).on('click', function(e) {
				e.preventDefault();
				changeTab(tabs.find(t => t[1].is($(this))));
			});

			// Return tabs
			return $(tabs);
		};

		// List selector
		$.fn.listSelector = function(options) {

			// Return given item
			if (['string', 'number'].indexOf(typeof options) > -1) {
				if (options === 'all') return $(this).toArray().map(el => $(el).data('_item'));
				return $(this).toArray().map(el => $(el).data('_item')).find(i => i[0] === options);
			}

			// Parse options
			options = Object.assign({
				selected: null,
				activeClass: 'active',
				value: null,
				change: () => {}
			}, options || {});

			// Get items
			const items = $(this).toArray().map((el, i) => [ (options.value ? $(el).data(options.value) : i), $(el), false ]);

			// Set items to element
			items.forEach(i => i[1].data('_item', i));

			// Set selected
			if (options.selected === null) {
				const selectedNode = items.find(t => t[0] === options.value);
				options.selected = !!selectedNode ? selectedNode[0] : (items.length ? items[0][0] : null);
			}

			// Holds current value
			let currentValue = null;

			// Item changer
			const changeItem = (item) => {
				// Check already selected
				if (!item || currentValue === item[0]) return;

				// Emit event
				const changeEvt = $.Event('change.item');
				$(this).trigger(changeEvt, item[0]);
				if (changeEvt.isDefaultPrevented()) return;

				// Maintain current active item
				const currentItem = items.find(t => t[0] === currentValue);
				if (currentItem) {
					currentItem[1]
						.removeClass(options.activeClass)
						.find("input[type='radio'], input[type='checkbox']").prop('checked', false);
				}

				// Select new item
				const newItem = items.find(t => t[0] === item[0]);
				if (newItem) {
					newItem[1]
						.addClass(options.activeClass)
						.find("input[type='radio'], input[type='checkbox']").prop('checked', true);
				}

				// Set items
				items.forEach(i => i[2] = (i === item));

				// Emit event
				const changedEvt = $.Event('changed.tab');
				newItem[1].trigger(changedEvt, currentValue = item[0]);

				// Callback
				options.change.call(options, item[0], item);
			};

			// Select default tab
			const initialSelected = items.find(t => t[0] === options.selected);
			changeItem(initialSelected);
			items.filter(t => t !== initialSelected).forEach(t => t[1].find("input[type='radio'], input[type='checkbox']").prop("checked", false));

			// Listen click event
			$(this).on('click', function(e) {
				//e.preventDefault();
				changeItem(items.find(t => t[1].is($(this))));
			});

			// Return items
			return $(items);
		};

		// Scroll to top
		$.fn.scrollToTop = function() {
			$(this).each(function(){
				var scrollDiv = $(this);
				window.addEventListener('scroll', () => $(scrollDiv).clearQueue().animate({ opacity: $(window).scrollTop() === 0 ? 0 : 1 }, 100), { passive: true });
				$(window).triggerHandler('scroll');
				$(this).css('opacity', 0).on('click', function(e){
					e.preventDefault();
					$("html, body").clearQueue().animate({ scrollTop: 0 }, "fast");
				});
			});
		};

		// Delay Keyup
		$.fn.delayKeyup = function(callback, ms){
			var timer = 0;
			$(this).each(function(){
				$(this).on('keyup', function(e) {
					var node = this;
					var timer = $(this).data("keyup_timer");
					if (timer) clearTimeout(timer);
					$(node).data("keyup_timer", setTimeout(function(){
						callback.apply($(node), [e]);
					}, ms));
				});
			});
			return $(this);
		};

		// Lazyload change src
		const _lazyLoad = $.fn.lazyload;
		$.fn.lazyload = function(options) {
			options = Object.assign({ src: 'data-original' }, options || {});
			return _lazyLoad.call(this, options);
		};

		// $().imagesLoaded()
		$.fn.imagesLoaded = function(callback) {
			var $images = this.find("img");
			if ($images.length === 0) return callback();
			var loadCount = $images.length;
			function IsImageOk(img) {
				if (!img.complete) return false;
				if (typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) return false;
				return true;
			}
			function CheckImages(imgs) {
				var imagesAllOk = false;
				$images.each(function(i, elem){
					imagesAllOk = IsImageOk(elem);
				});
				return imagesAllOk;
			}
			var checkImages = setInterval(function(){
				if (!CheckImages($images)) return;
				clearInterval(checkImages);
				callback();
			}, 50);
		};

		// EqualHeights
		$.fn.equalHeight = function(cb) {
			if (!cb) cb = function(){};
			var e = new $.Event("init.equal.height");
			$('body').triggerHandler(e);
			if (e.isDefaultPrevented()) return cb(false);
			(function(nodes, cb){
				if (nodes.length === 0) return cb();
				nodes.imagesLoaded(function(){
					var tallest = 0;
					nodes.each(function(elemIndex, elem) {
						var thisHeight = $(elem).height();
						if(thisHeight > tallest) tallest = thisHeight;
					});
					nodes.height(tallest);
					return cb(tallest);
				});
			})(this, cb);
		};

		// Set Loading
		$.fn.dataLoading = function(state) {
			if (typeof state != "boolean") state = !$(this).hasClass("data-loading");
			if (state === true && $(this).hasClass("data-loading")) return this;
			return (state ? $(this).addClass("data-loading") : $(this).removeClass("data-loading"));
		};

		// Add option to selectbox
		$.fn.addOption = function(name, value) {
			return $(this).each(function(){
				if (this.nodeName != "SELECT") return;
				var _option = document.createElement("option");
				if (typeof value == "undefined") value = name;
				$(_option)
					.attr("value", value)
					.html(name);
				$(this).append(_option);
			});
		};

		// Clear node
		$.fn.clear = function() {
			return $(this).each(function(){
				switch (this.nodeName) {
					case "SELECT":
						$(this).children("option").remove();
						break;
					case "INPUT":
						if ($(this).attr("type") == "checkbox")
							this.checked = false;
						else
							$(this).val("");
						break;
					case "TEXTAREA":
						$(this).val("");
						break;
					default:
						$(this).html("");
				}
			});
		};

		// Checkbox
		$.fn.checked = function(){
			var node = $(this)[0];
			if (node.nodeName.toLowerCase() != "input" || (["checkbox", "radio"]).indexOf($(node).attr("type").toLowerCase()) === -1) return;
			return node.checked === true;
		};
		// Check checkbox
		$.fn.check = function(state){
			var node = $(this)[0];
			if (node.nodeName.toLowerCase() != "input" || (["checkbox", "radio"]).indexOf($(node).attr("type").toLowerCase()) === -1) return;
			node.checked === state || true;
			$(node).triggerHandler("change");
		};

		// Override orginal val function
		_val = $.fn.val;
		$.fn.val = function(newVal) {
			if (newVal) {
				$(this).each(function(){
					if (this.nodeName == "SELECT") $(this).attr("data-selected", newVal);
				});
			}
			return _val.apply(this, arguments);
		};

		// Reset All
		$.fn.reset = function() {
			return $(this).each (function() {
				this.reset();
			});
		};

		// Convert selectbox to inputbox
		$.fn.convertInputBox = function(_options){
			if (typeof options != "undefined" && !$.isPlainObject(_options)) _options = {show: _options};
			_options = $.extend({
				inputClass: "from_select_box",
				show: true,
				inputValue: ""
			}, _options || {});
			if (_options.show === false && !$(this).data("clone_input")) return $(this);
			return $(this).each(function(){
				if (this.nodeName != "SELECT") return;
				var input = $(this).data("clone_input");
				if (!input) { // Create input
					input = document.createElement("input");
					$(input)
						.attr("class", $(this).attr("class"))
						.attr("style", $(this).attr("style"))
						.attr("type", "text")
						.addClass(_options.inputClass)
						.data("clone_select", this)
						.data("clone_name", $(this).attr("name"))
						.hide();
					$(this)
						.after(input)
						.data("clone_input", input);
				}
				if (_options.show === true) {
					$(this)
						.attr("name", $(input).data("clone_name") + "_clone")
						.hide();
					$(input)
						.attr("name", $(input).data("clone_name"))
						.val(_options.inputValue || $(this).attr("data-selected"))
						.show();
					return;
				}
				$(input)
					.attr("name", $(input).data("clone_name") + "_clone")
					.hide();
				$(this)
					.attr("name", $(input).data("clone_name"))
					.show();
			});
		};

		// Select option
		$.fn.selected = function(){
			var node = $(this)[0];
			if (node.nodeName.toLowerCase() != "option") return;
			return node.selected === true;
		};

		// Fill select box
		$.fn.fill = function(data){
			return $(this).each(function(){
				switch (this.nodeName) {
					case "SELECT":
						if (!Array.isArray(data)) data = [data];
						var node = this;
						data.forEach(function(arrElement){
							var name = typeof arrElement == "object" ? arrElement.name : arrElement;
							var value = typeof arrElement == "object" ? arrElement.value : name;
							$(node).addOption(name, value);
						});
						break;
					case "INPUT":
						if ($(this).attr("type") == "checkbox")
							this.checked = (data === true) ? true : false;
						else
							$(this).val(data);
						break;
					case "TEXTAREA":
						$(this).val(data);
						break;
					default:
						$(this).html(data);
				}
			});
		};

		// Set node
		$.fn.set = function(data){
			return $(this).each(function(){
				switch (this.nodeName) {
					case "INPUT":
						if (["checkbox", "radio"].indexOf($(this).attr("type")) > -1) return this.checked = (data == true) ? true : false;
						$(this).val(data);
						break;
					default:
						$(this).val(data);
				}
			});
		};

		// Slide by mouse tiny images in product detail bottom of main picture
		$.fn.slideByMouse = function(options) {
			var target = this;
			var options = extend({
				scanOffset: 0
			}, options || {});
			// Set padding to zero
			target.css("padding", "0px");
			// Set mouse to object
			var Mouse = { x:0, y:0 };
			// Set or Get default values
			target.data('LeftOffset', target.outerWidth() - target.innerWidth());
			target.data('Width', target.outerWidth());
			target.data('Left', target.offset().left);
			target.data('Right', target.data('Left') + target.data('Width') + (target.data('LeftOffset') / 2));
			target.data('Top', target.offset().top);
			target.data('Bottom', target.outerHeight() + target.data('Top'));
			// Set slide elements
			target.data('Slides', (function(t){
				var slideCount = parseInt(t.find('.urun_resmi_kucuk_content').length, 10);
				var oneWidth = t.find('.urun_resmi_kucuk_content:last').outerWidth();
				return {
					Count: slideCount,
					Width: oneWidth * slideCount,
					oneWidth: oneWidth
				};
			})(target));
			// Set container
			target.data('Container', target.find('.urun_resmi_kucuk_container'));
			target.data('Container').data('Width', target.data('Slides').Width);
			target.data('Container').css('width', target.data('Container').data('Width'));
			target.data('Container').data('CurrentLeft', function(){
				return parseFloat(target.data('Container').css("left").replace("px", ""), 10);
			});
			target.data('Container').data('MouseXOffset', function(){
				return Mouse.x - target.data('Left') - (options.scanOffset / 2);
			});
			target.data('Container').data('SetLeft', function(leftPos){
				target.data('Container').clearQueue();
				if (Math.abs(Math.abs(target.data('Container').data('CurrentLeft')()) - Math.abs(leftPos)) > 80)
					return target.data('Container').animate({ left: leftPos }, 100);
				target.data('Container').css("left", leftPos + "px");
			});
			// Set left to zero
			target.data('Container').data('SetLeft')(0);
			target.data('Container').data('SlideOffset', target.data('Container').data('Width') - target.data('Width'));
			target.data('Container').data('GetMouseOffset', function(){
				return (target.data('Container').data('SlideOffset') * target.data('Container').data('MouseXOffset')()) / (target.data('Width') - options.scanOffset);
			});

			// Set scan offset to half of width
			if (options.scanOffset !== 0)
				options.scanOffset = (target.data('Width') * options.scanOffset) / 100;

			// Load if required
			if (target.data('Slides').Width >= target.data('Width'))	{
				target.on('mousemove', function(e){
					Mouse.x = e.pageX;
					Mouse.y = e.pageY;
					if (Mouse.x < (options.scanOffset / 2)  + target.data('Left'))
						Mouse.x = target.data('Left') + (options.scanOffset / 2);
					else if (Mouse.x > (target.data('Left') + (target.data('Width') - (options.scanOffset / 2))))
						Mouse.x = (target.data('Left') + (target.data('Width') - (options.scanOffset / 2)));
					target.data('Container').data('SetLeft')(0 - target.data('Container').data('GetMouseOffset')());
				});
			}
		};

		// Toggle disable/enable
		$.fn.toggleDisable = function(){
			$(this).each(function(){
				$(this).prop("disabled") ? $(this).enable() : $(this).disable();
			});
		};

		// Set disable
		$.fn.disable = function(){
			$(this).find("input, select, textarea").add(this).each(function(){
				$(this).prop("disabled", true);
			});
		};

		// Set enable
		$.fn.enable = function(){
			$(this).find("input, select, textarea").add(this).each(function(){
				$(this).prop("disabled", false);
			});
		};

		// Set readonly
		$.fn.readOnly = function(_state){
			if (typeof _state != "boolean") _state = true;
			return $(this).each(function(){
				$(this).prop("readOnly", _state);
			});
		};

		// Disable Bind
		$.fn.bindDisable = function(){
			return $(this).each(function(){
				var fn = $(this).attr("data-disable") || $(this).attr("data-enable");
				var _fn = $(this).attr("data-enable") ? "enable" : "disable";
				var value = fn[0] == "#" || fn[0] == "." ? $(fn) : eval(fn);
				if (value instanceof $) {
					(function(listener, target, _fn){
						listener.on("change click keyup", function(){
							$(this).attr("type") == "checkbox" && this.checked || $(this).attr("type") != "checkbox" && $(this).val() ? $(target)[_fn]() : $(target)[_fn == "enable" ? "disable" : "enable"]();
						}).triggerHandler("change");
					})(value, this, _fn);
					return;
				}
				value ? $(this)[_fn]() : $(this)[_fn == "enable" ? "disable" : "enable"]();
			});
		};

		// JCarousel Wrapper
		$.fn.platinCarousel = function(_options){
			if (!$.fn.jcarousel) return console.error("JCarousel not found!");

			_options = $.extend(PM.Get("Configure", "JCarousel"), _options || {});

			return $(this).each(function(){
				if (!$(this).find("li")[0]) return $(this).next().remove();

				$(this).find("li").addClass("jcarousel-item");

				// Emit event for init jcarousel
				var e = new $.Event('init.jcarousel');
				PM.emitEvent(e.type, [e, this, _options]);
				if (e.isDefaultPrevented()) return $(this).next().remove();

				// Prevent LazyLoad
				$(this).find("img[data-original]").each(function(){
					$(this)
						.attr("src", $(this).attr("data-original"))
						.attr("data-lazyload-ready", "true");
				});

				// Equal carousel height
				if (_options.equalHeight && $(this).find(".urun").length > 0) $(this).find(".urun").equalHeight();

				_options.autoscroll.target = "+=" + _options.group.toString();

				var wrapper = document.createElement("div");
				var container = document.createElement("div");

				$(container)
					.addClass("jcarousel-container jcarousel-container-horizontal")
					.attr("style", "position: relative; display: block;")
					.prependTo($(this).closest("div"));

				var buttons = $();
				if (_options.buttons === true) {
					buttons = buttons.add($("<div class=\"jcarousel-prev jcarousel-prev-horizontal\" style=\"display: block;\"></div>"))
					buttons = buttons.add($("<div class=\"jcarousel-next jcarousel-next-horizontal\" style=\"display: block;\"></div>"))
				}

				(function(wrapper, list, container, buttons, _options){
					$(wrapper)
						.addClass("jcarousel jcarousel-clip jcarousel-clip-horizontal")
						.append(list)
						.appendTo(container)
						.jcarousel(_options.jcarousel)
						.jcarouselAutoscroll(_options.autoscroll)

					$(buttons)
						.appendTo(container);

					if (_options.prev) if (prevButton = _options.prev(wrapper)) _options.prev(wrapper).on("click", function(){
						$(wrapper).jcarousel('scroll', _options.autoscroll.target.replace("+", "-"));
					});
					if (_options.next) if (nextButton = _options.next(wrapper)) nextButton.on("click", function(){
						$(wrapper).jcarousel('scroll', _options.autoscroll.target.replace("-", "+"));
					});
				})(wrapper, this, container, buttons, _options);
			});
		};
	};

	// Try making plugin
	PlatinMarket.makeJQueryPlugins();

	// PM Ready Event
	PlatinMarket.prototype.on("ready", function(){

		// Set Validator Custom Methods
		if ($.validator) {
			if (PM.Get("Configure", "ValidationMethods")) {
				var _validators = PM.Get("Configure", "ValidationMethods");
				Object.keys(_validators).forEach(function(_validatorName){
					$.validator.addMethod(_validatorName, _validators[_validatorName], PM.Get("Configure" , "ValidationRules._messages" + _validatorName));
				});
			}
		}

		// Bind Disable
		$("[data-disable], [data-enable]").bindDisable();

	});

	return [ PlatinMarket, Statr ];
});
